const LOG_ENTRY_PREFIX = 'Mason X-Ray RTC connection:';

export function log(
  msg: string,
  evt?: Event | Error | Record<string, unknown>,
  level: 'debug' | 'error' | 'info' | 'log' | 'warn' = 'log'
) {
  // TODO: Un-comment this once testing in staging is complete
  // if (process.env.NODE_ENV !== 'development' && level !== 'error') {
  //   // only allow errors to be logged in production
  //   return;
  // }

  const logFn =
    level === 'debug'
      ? console.debug
      : level === 'info'
      ? console.info
      : level === 'log'
      ? console.log
      : level === 'error'
      ? console.error
      : console.warn;

  if (evt) {
    logFn(LOG_ENTRY_PREFIX, msg, evt);
  } else {
    logFn(LOG_ENTRY_PREFIX, msg);
  }
}
